import { COMPANIES } from "../../types/const";

const companyNoParser = (companyNo: string | number): COMPANIES => {
  const companyNoStr = companyNo.toString();
  switch (companyNoStr) {
    case "02":
    case "2":
      return "Dalakraft";
    case "03":
    case "3":
      return "Enkla";
    default:
      throw new Error("Invalid company number");
  }
};

export default companyNoParser;
